import styled from 'styled-components';
import { rgba } from 'polished';

import { cBC44FF, cFFFFFF } from '#/colors';

import {
  TERMS_OF_SERVICE_URL,
  ABOUT_RESTRICTED_PERSONS_URL,
} from '#/routes-external';

export default function LegalDisclaimer() {
  return (
    <Container>
      By connecting a wallet, you agree to{' '}
      <ExternalLink href={TERMS_OF_SERVICE_URL}>
        Paradex Terms of Service
      </ExternalLink>{' '}
      and represent and warrant to Paradex that you are not a{' '}
      <ExternalLink href={ABOUT_RESTRICTED_PERSONS_URL}>
        Restricted Person
      </ExternalLink>
      .
    </Container>
  );
}

export const Container = styled.div`
  color: ${rgba(cFFFFFF, 0.5)};
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
`;

const ExternalLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener',
})`
  color: ${cBC44FF};
`;
